export default __webpack_public_path__ + "static/media/post-company-2.d7b16820.png";